import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";
const MONO = "font-mono text-sm";
export const FormulaBar = ({
  address,
  value,
}: {
  address: string | null;
  value: string | undefined;
}) => (
  <Stack
    gap="none"
    align="stretch"
    direction="row"
    className="flex min-h-[30px] shrink-0 items-stretch border-b border-stroke-tertiary bg-surface-primary"
  >
    <span className="flex min-w-[52px] items-center justify-center border-r border-stroke-tertiary bg-surface-secondary px-2 text-sm font-semibold text-secondary-text">
      {address ?? "Cell"}
    </span>
    <span
      className={cn(
        "flex max-h-20 min-w-0 flex-1 items-center overflow-auto whitespace-pre-wrap break-words px-2.5 py-1",
        value ? MONO : "text-sm italic text-tertiary-text",
      )}
    >
      {value || "Select a cell to see its value"}
    </span>
  </Stack>
);
